import React from 'react';
import { motion } from 'framer-motion';
import { Zap } from 'lucide-react';
export function MechanismSection() {
  return <section className="py-16 md:py-24 px-6 bg-brand-card relative overflow-hidden" data-id="element-89">
      {/* Accent glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-lg h-96 bg-brand-accent/5 blur-[100px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-90" />

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-91">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-brand-surface border-2 border-brand-accent/30 rounded-2xl p-8 md:p-12 text-center shadow-[0_0_40px_rgba(212,160,23,0.1)]" data-id="element-92">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-accent/10 mb-6" data-id="element-93">
            <Zap className="w-8 h-8 text-brand-accent" aria-hidden="true" data-id="element-94" />
          </div>

          <h2 className="font-heading font-bold text-3xl md:text-5xl text-brand-text uppercase mb-6" data-id="element-95">
            La Optimización Metabólica Hormonal{' '}
            <span className="text-brand-accent" data-id="element-96">(OMH)</span>
          </h2>

          <div className="font-body text-lg md:text-xl text-brand-muted leading-relaxed space-y-6 max-w-3xl mx-auto" data-id="element-97">
            <p data-id="element-98">
              A diferencia del ejercicio tradicional, el método OMH utiliza
              micro-estímulos de tensión de{' '}
              <strong className="text-brand-text" data-id="element-99">5 minutos</strong> que envían
              una señal directa a tu cerebro para reactivar la producción
              natural de testosterona.
            </p>
            <p className="text-brand-accent font-medium text-xl md:text-2xl" data-id="element-100">
              "No se trata de sudar por horas, sino de recalibrar tu química
              interna para que tu cuerpo deje de almacenar grasa y empiece a
              generar vitalidad."
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}